import React from 'react';
import { ErrorMessage } from '@common/components/ErrorMessage';
import { Box } from '@components/Box';
import { Field, TextArea } from '@components/FormElements';
import { Stack } from '@components/Stack';

type BusinessAdditionalInformationProps = {
  value: string;
  onChange: () => void;
  label: string;
  error?: string;
};

export const BusinessAdditionalInformation = (
  props: BusinessAdditionalInformationProps
) => {
  const { error, onChange, value, label } = props;

  return (
    <Stack spacing="small">
      <Field
        label={label}
        message={
          error && (
            <Box marginTop="xxsmall">
              <ErrorMessage>{error}</ErrorMessage>
            </Box>
          )
        }
      >
        <TextArea
          testID="additional-information-input-field"
          onChange={onChange}
          value={value}
          tone={error ? 'danger' : 'neutral'}
        />
      </Field>
    </Stack>
  );
};
